import React from 'react'
import useMedia from 'use-media'

import { Button, ButtonProps, theme } from '@clear/design-system'

const aboveMobile = theme?.breakpoints?.[0] as string

export const BackButton: React.FC<ButtonProps> = (props) => {
  const isAboveMobile = useMedia({ minWidth: aboveMobile })

  return (
    <Button
      text="Back"
      textProps={{
        display: ['none', 'inline'],
        variant: 'regular',
      }}
      size={isAboveMobile ? 'large' : 'small'}
      icon="chevron-left"
      iconPosition="left"
      variant="secondary"
      data-cy="back"
      {...props}
    />
  )
}

export const ContinueButton: React.FC<ButtonProps> = ({
  text = 'Continue',
  id,
  ...props
}) => {
  const isAboveMobile = useMedia({ minWidth: aboveMobile })

  return (
    <Button
      text={text}
      id={id}
      textProps={{
        variant: 'regular',
      }}
      size={isAboveMobile ? 'large' : 'small'}
      icon={isAboveMobile ? 'chevron-right' : undefined}
      iconPosition="right"
      data-cy="continue"
      type="submit"
      {...props}
    />
  )
}
